/**
 * User Contacts Page
 * 
 * Standalone page for managing user contacts (caregiver QR code and saved contacts).
 * Accessed via the hamburger menu. Uses the same layout style as Settings.
 * 
 * @module UserContacts
 */

import React from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import { Users } from "lucide-react";
import { useCaregiverTranslation } from "@/hooks/useCaregiverTranslation";
import { CaregiverQRSettings } from "@/components/settings/CaregiverQRSettings";
import { useAuth } from "@/hooks/useAuth";

export default function UserContacts() {
  const { t, dir } = useCaregiverTranslation();
  const { user } = useAuth();

  return (
    <MainLayout>
      <div className="flex-1 flex flex-col min-h-0" dir={dir}>
        {/* Header - same style as Settings */}
        <header className="flex-shrink-0 flex items-center gap-3 px-6 py-4 border-b border-primary bg-card/50">
          <h1 className="text-2xl font-bold">{(t as any)("userContactsTitle")}</h1>
        </header>

        {/* Content */}
        <div className="flex-1 min-h-0 overflow-y-auto p-6">
          <div className="space-y-4 max-w-2xl">
            {user ? (
              <CaregiverQRSettings />
            ) : (
              <div className="text-center py-12 text-muted-foreground">
                <Users className="w-12 h-12 mx-auto mb-4 opacity-50" />
                <p>{(t as any)("loginRequired")}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
